import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import { ibSpinOpts } from '../../../helper-functions/applicationCommonValues';
import {
    isAfterField,
    convertDateByLang,
    monthDate,
    createDateByLangStr,
    createDateByLangApplications,
    numbersWithDashSlash,
    noAlphabets
} from '../../../helper-functions/helper-functions';
import {
    createUpdateApplicationService,
    checkExpiredAndTriggerValidation,
    goToFirstError
} from '../../../helper-functions/services';
import section from '../subcomponents/img/all/section-configs';
import inputSection from '../subcomponents/input-section.vue';
import Step1Mixin from '../mixins/Step1Mixin';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, Step1Mixin],
    components:{
        'date-picker': datePicker,
        'age-switch': ageSwitch,
        // 'save-share-block' : saveShareBlock,
        'save-share': () => import('../../../components/forms/component.save-share.vue'),
        'input-section': inputSection
    },
    props:['form-data'],
    data: function() {
        return {
            form:{
                destinationStr: [],
                travelerInfos: ibJS.application ? ibJS.application.travelerInfos : [],
            },
            totalChildren: 0,
            formSending: false,
            showTravelerValidation: false,
            countries: ibJS.countries,
            popularCountries: ibJS.popularCountries,
            multiselectFocus : false,
            USandTerritories: ["USA","ASM","GUM","MNP","PRI","UMI","VIR"],
            requireRuleError: false,
            section: section,
            submitted: false,
            ageGroup: null,
            firstClick: 0,
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            hasChildfromQuote: false,
            hasSpousefromQuote: false,
            disableChildAddition: false,
        }
    },
    validations: function(){
        var validations = {
            form:{
                startDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                },
                endDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    isAfterStartDate: isAfterField('startDate',this.submitted)
                },
                travelerInfos:{
                    $each:{
                        age:{
                            requiredOnlyPrimary,
                            requiredChild,
                            childAge,
                            requiredAdditional
                        }
                    }
                },
            }
        };

        function requiredOnlyPrimary(x,a){
            return !((a.travelerType === 'primary' || a.travelerType === '') && (x === '' || x === null || x === undefined));
        }

        function childAge(x,a){
            return a.travelerType === 'child' && x !== undefined && x > 17 && [406,532,546].indexOf(this.form.planId) === -1  ? false
                : !(a.travelerType === 'child' && x !== undefined && x > 18);
        }

        function requiredChild(x,a) {
            if(!this.hasChildfromQuote) {
                return this.form.travelerInfos.length > 3 && a.travelerType === 'child' && (x === '' || x === null || x === undefined) ? false : true;            
            } else {
                return a.travelerType === 'child' && (x === '' || x === null) ? false : true;     
            }
        }

        function requiredAdditional(x,a) {
            if(this.hasSpousefromQuote &&  a.travelerType === 'spouse') {
                return (x === '' || x === null || x === undefined) ? false : true;
            } else {
                return true;
            }
        }


        function checkDateFormat(x){
            return !(monthDate(x) === false && !this.hideDateError);
        }

        return validations;
    },

    mounted:function(){
        convertDateByLang(this.form,window.globalLanguage.lang);
    },
    created: function(){
        var self = this;
        
        if(self.application != null){
            if(this.application.travelerInfos !== null && this.application.travelerInfos.length) {
                /* only primary and spouse have age value*/
                let ageGreaterThanZero = 0;
                for(var i=0;i<self.application.travelerInfos.length;i++){
                    if(self.application.travelerInfos[i] && self.application.travelerInfos[i].travelerType=='child' && self.form.travelerInfos[i].age==-1) {
                        this.hasChildfromQuote = true;
                    }

                    if(self.application.travelerInfos[i] && self.form.travelerInfos[i].age > 0) {
                        ageGreaterThanZero += 1;
                    }
                }
                // if(ageGreaterThanZero === 2) {
                //     this.hasSpousefromQuote = true;
                // }
                if(self.isMobile && self.form.travelerInfos.length > 1) {
                    let spouseTravelers = self.form.travelerInfos.filter(traveler => traveler.travelerType === 'spouse');
                    if(spouseTravelers.length == 0) {
                        let newTraveler = {
                            age: null,
                            tripCost: null,
                            quotePrice:null,
                            travelerType: 'spouse'
                        };
                        self.form.travelerInfos.splice(1, 0, newTraveler);
                    }
                }
            }
            self.travelersOpened = true;
            for(var i=0;i<self.form.travelerInfos.length;i++){
                if (i === 0) {
                    self.form.travelerInfos[0].travelerType = 'primary';
                }
                if(self.form.travelerInfos[i].age === -1){
                    self.form.travelerInfos[i].age=null;
                    self.showChildErrorText=true;
                    self.showTravelers=true;
                }

                delete self.form.travelerInfos[i].birthDate;
            }

            // Object.keys(self.form.rules).forEach(key => {
            //     self.form.rules[key] === 'yes' ? self.form.rules[key] =  true : self.form.rules[key] === 'no' ? self.form.rules[key] = false : null;
            // });
            this.initialSumChildren();
        }
        else {
            self.form.travelerInfos[0] = self.form.travelerInfos[0] || {};
            self.form.travelerInfos[0].travelerType = 'primary';

            if (self.form.travelerInfos[1]) {
                self.form.travelerInfos[1].travelerType = 'spouse';
            }

            self.form.travelerInfos.splice(2,1);
            if(!self.isMobile) this.addChild();
        }

        if(this.application && (this.application.travelerInfos === null || !this.application.travelerInfos.length)) {
            self.form.travelerInfos[0] = self.form.travelerInfos[0] || {};
            self.form.travelerInfos[0].travelerType = 'primary';

            if (self.form.travelerInfos[1]) {
                self.form.travelerInfos[1].travelerType = 'spouse';
            }
            if (self.form.travelerInfos[2]) {
                self.form.travelerInfos[2].travelerType = 'child';
            }

        }

        let needChild = true;
        let needSpouse = true;
        for (var i = 1; i < self.form.travelerInfos.length; i++) {
            if (self.form.travelerInfos[i].travelerType === 'spouse') {
                needSpouse = false;
            }
            else if (self.form.travelerInfos[i].travelerType === 'child') {
                needChild = false;
            }
            if(needChild === false && needSpouse === false) {
                break;
            }
        }

        if(self.isMobile) {
            needChild = false;
            needSpouse = false;
        }

        if (needChild) {
            this.addChild();
        }
        if (needSpouse) {
            this.addSpouse();
        }

        // this.ageGroup = this.computeMaxMonths;

        checkExpiredAndTriggerValidation.call(this);

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });

    },
    computed:{
        showMobileError: function() {
            return this.$v.form.$error;
        },
        selectMultiple:function(){
            return true;
        },
    },
    watch:{
        'form.endDate': function(){
            this.createDate();
        },
        'form.startDate' : function(){
            this.createDate();
        },
    },
    methods: {
        createQuote: function () {
            this.$v.$touch();
            this.form.travelerInfos[0].homeCountry =  this.form.homeCountry;
            this.form.destinationStr = [];
            this.form.destinationStr.push("");
            
            for(var i=0;i<this.form.travelerInfos.length;i++){
                var travelerType = this.form.travelerInfos[i].travelerType || '';   
                if(travelerType === 'spouse' && i != 1 && this.form.travelerInfos[1].travelerType === 'spouse') {
                    travelerType = 'child';
                }
                this.form.travelerInfos[i].travelerType = travelerType;
            }

            var quoteResultsURL='/api/'+ibJS.productName+'/quote-results/?lang='+window.globalLanguage.lang;

            if (!this.$v.$invalid) {

                this.showQuestions = this.showRuleQuestions !== '';

                Vue.nextTick(() => {

                        let spinTarget=this.$refs.btnSpinnerModal;
                        let spinner = new IBSpinner(ibSpinOpts).spin(spinTarget);

                        // this.transformRulesArray();
                        this.spliceTravelers();

                        var _this = this;
                        Vue.nextTick(() => {

                            let langBasedData = Object.assign({}, this.form);
                            createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                            createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application');
                            this.submitted = true;
                        });
                        this.submitted = false;

                    // }
                    // else if(!ruleCheck) {
                    //     Vue.nextTick(() => this.$v.form.rules.$reset() );
                    // }
                })
            }
            else {
                Vue.nextTick(() => goToFirstError() );
            }
        },
        disableInput(){
            if(document.getElementById('homeCountrySelect')) {
                let homeCountryDropdown = document.getElementById('homeCountrySelect')
                homeCountryDropdown.disabled = true;
                homeCountryDropdown.style.backgroundColor = "#f4f4f4";
                homeCountryDropdown.style.cursor = 'initial';
                homeCountryDropdown.style.backgroundImage = 'none';
            }

        },
        initialSumChildren: function(){
            for(let i in this.form.travelerInfos) {
                if(this.form.travelerInfos[i].travelerType === 'child') {
                    this.totalChildren ++;
                }
            }
        },
        sumChildren: function(x) {
            x === true ? this.totalChildren ++ : this.totalChildren --;
            if(this.totalChildren === 10) {
                this.disableChildAddition = true;
            }
        },
        createDate: function(){
            if(this.form.startDate!='' && this.form.endDate!=''){
                var startDate = createDateByLangStr(this.form.startDate,'en');
                var endDate = createDateByLangStr(this.form.endDate,'en');
            }
        },
        toggleTravelers: function () {
            this.showTravelers = !this.showTravelers;
            this.travelersOpened = true;
        },
        addTraveler: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:''
            };
            this.form.othersListArray.push(newTraveler);
        },
        addChild: function(){
            let isChild = this.form.travelerInfos.length >= 2;
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType: isChild ? 'child' : 'spouse'
            };
             if (!this.disableChildAddition) {
                this.form.travelerInfos.push(newTraveler);
                if(isChild) this.sumChildren(true)
            }
        },
        deleteChild: function(index){
            this.clickedDelete = true;
            this.showChildErrorText = false;
                
            if(index == 1) {
                this.form.travelerInfos.splice(this.form.travelerInfos.length - 1, 1);
            } else {
                this.form.travelerInfos.splice(index, 1);
            }
            this.disableChildAddition = false;

            this.sumChildren?.(false);

        },
        addSpouse: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:'spouse'
            };
            this.form.travelerInfos.splice(1,0,newTraveler);
        },
        resetAgeValidation: function(index){
            this.showChildErrorText = false;
            if(!(/^\d+$/.test(this.form.travelerInfos[index].age))){
                this.form.travelerInfos[index].age=null;
            }
        }
    }
};
